//#region ../src/sensors/permission-state.ts
const STATES = new Set([
	"granted",
	"denied",
	"prompt"
]);
/**
* Queries `navigator.permissions` for `name`. Never prompts and never
* rejects. iOS Safari answers `prompt` for geolocation even where the page
* may ask; that stays `prompt`.
*/
async function queryPermissionState(name) {
	if (typeof navigator === "undefined" || !navigator || typeof navigator.permissions?.query !== "function") return "unknown";
	try {
		const state = (await navigator.permissions.query({ name }))?.state;
		return typeof state === "string" && STATES.has(state) ? state : "unknown";
	} catch {
		return "unknown";
	}
}
/** The geolocation permission; `unknown` where there is no geolocation API. */
async function geolocationPermissionState() {
	if (typeof navigator === "undefined" || !navigator?.geolocation) return "unknown";
	return queryPermissionState("geolocation");
}
//#endregion
export { geolocationPermissionState, queryPermissionState };
